import React, {useState} from 'react';
import {Image, ImageStyle} from 'react-native';
import {DimensionValue} from "react-native/Libraries/StyleSheet/StyleSheetTypes";
import MainStyle from "../../MainStyle";
import arrowDown from '../assets/img/arrow-down.png';
import SelectModal from "../modals/SelectModal";
import {outline_0} from "../constants";
import P from "../lib/P";
import {colors} from "../assets/styles/colors";
import {toCapitalize} from "../utils";
import Btn from "./Btn";

type ItemType = { value: string, label: string, customLabel?: string };

const defaultItems: ItemType[] = [];

for (let i = 10; i > 0; i--) {
  defaultItems.push({value: `+${i}`, label: `+${i}`});
}

defaultItems.push({value: 'N/A', label: 'N/A'});
defaultItems.push({value: '0', label: '0'});

for (let i = 1; i <= 30; i++) {
  defaultItems.push({value: `${i}`, label: `${i}`});
}

type Props = {
  placeholder?: string, label?: string, value: string, onChangeText: (val: string) => void, mt?: DimensionValue,
  customItems?: ItemType[], mb?: DimensionValue, secondItems?: ItemType[], w?: DimensionValue, borderRadius?: number,
  h?: DimensionValue, pl?: DimensionValue, pr?: DimensionValue, bg?: string, borderColor?: string, color?: string,
  textAlign?: "center" | "auto" | "left" | "right" | "justify", icon?: any, iconSize?: ImageStyle['width'],
  disabledItemsBottom?: boolean, popupTitle?: string, disabled?: boolean, fontSize?: number, errorText?: string,
  fontWeight?: '400' | '500' | '600' | '700'
};

const Select = (props: Props) => {
  const {placeholder, label, value, mt, customItems, mb, secondItems, w, borderRadius, h, pl, pr, textAlign} = props;
  const {bg, borderColor, color, icon, iconSize, disabledItemsBottom, popupTitle, disabled, fontWeight} = props;
  const {fontSize, errorText} = props;
  const [visible, setVisible] = useState(false);
  const items = customItems ?? defaultItems;
  const selectedItem = items.find(el => el.value === value);
  const fontFamily = fontWeight === '400' ? 'Barlow-Regular' : fontWeight === '600' ? 'Barlow-SemiBold' : fontWeight === '700' ? 'Barlow-Bold' : 'Barlow-Medium';

  const onResume = (val?: string) => {
    setVisible(false);
    if (val) props.onChangeText(val);
  };

  return (
    <>
      {label && <P ta="center" fs={12} opacity={0.5} mt={mt}>{label}</P>}

      <Btn rounded={borderRadius || 4} borderColor={borderColor || colors.blue} pr={disabled ? undefined : pr}
           pl={disabled ? undefined : pl} bg={bg || colors.popupDropBg} borderWidth={1} px={9} h={h || 60} row
           alignItems="center" mb={mb} w={w} style={[outline_0]} onPress={() => setVisible(true)} disabled={disabled}>
        <P color={disabled ? 'white' : color ? color : colors.lightBlue} flex={1} fs={fontSize || 22}
           fontFamily={fontFamily} ta={disabled ? 'center' : textAlign ? textAlign : 'center'}>
          {selectedItem?.customLabel || selectedItem?.label || placeholder}
        </P>

        {!disabled && (
          <Image source={icon || arrowDown} style={[...styles.down_s, {width: iconSize, height: iconSize}]}/>
        )}
      </Btn>

      {errorText && (
        <P flex={1} ta="center" fw="500" fs={12} color={colors.newDangerText}>{toCapitalize(errorText)}</P>
      )}

      <SelectModal
        visible={visible} onResume={onResume} value={value} items={items} secondItems={secondItems}
        disabledItemsBottom={disabledItemsBottom} popupTitle={popupTitle}
      />
    </>
  );
};

const styles = {
  select_s: [
    MainStyle.b_r_4, MainStyle.b_c_blue, MainStyle.bc_popupDropBg, MainStyle.b_w_1, MainStyle.p_x_9, MainStyle.h_60,
    MainStyle.row, MainStyle.a_i_c
  ],
  down_s: [MainStyle.w_10, MainStyle.h_12, MainStyle.rm_center, MainStyle.absolute, {right: 16}]
};

export default React.memo(Select);
